<template>
  <template v-if="loadedOrD2C">
    <ChatBotSmoochM3
      :chatBotMetadata="chatBotMetadata"
      :force-chat-bot-init="is2StepFlowInFirstPart().value"
    />
  </template>
</template>
<script setup lang="ts">
import { computed, ref, watchEffect } from "vue";
import { getLanguageName } from "@/apps/merchant3/shared-helpers/language.helper";
import { useStore } from "vuex";
import { UserTypes } from "@/enums/index.js";
import ChatBotSmoochM3 from "@/apps/merchant3/components/chatbot/ChatBotSmoochM3.vue";
import {is2StepFlowInFirstPart, isDirectToCustomerFlow} from "@/apps/merchant3/helpers/checkoutFlows";
import { chatBotProductEnum } from "@/apps/merchant3/enums/chatBotProductEnum";

const store = useStore();
const isMerchantCountryLoaded = ref(false);
const isSalesClerkLoaded = ref(false);
const isKiosk = sessionStorage.getItem("isKiosk");

const loadedOrD2C = computed(() => {
  return (
    (isMerchantCountryLoaded.value && isSalesClerkLoaded.value) ||
    isDirectToCustomerFlow.value
  );
});

const chatBotMetadata = computed(() => {
  const clerk = store.state.clerk?.clerk;
  const merchant = store.state.merchant?.merchant;
  const cart = store.state.carts;

  const salesClerkName = clerk?.salesClerkName;
  const complexName = `${merchant?.merchantName}/${clerk?.salesClerkName}/${
    cart?.cartTag || ""
  }`;
  const name = merchant?.country === "ZA" ? salesClerkName : complexName;

  let chatBotConfig = {
    name: name,
    userType: UserTypes.CLERK,
    language: getLanguageName(),
    salesClerkId: clerk?.salesClerkId,
    clerkId: clerk?.salesClerkId,
    clerkName: clerk?.salesClerkName,
    clerkToken: clerk?.chatBotApiToken,
    clerkTag: clerk?.salesClerkTag,
    merchantId: merchant?.merchantId,
    merchantName: merchant?.merchantName,
    adminName: merchant?.adminName,
    adminId: merchant?.adminId,
    country: merchant?.country,
    cartTag: store.state.carts?.cartTag,
    carttag: cart?.cartTag,
    phone: clerk?.salesClerkPhoneNumber
      ? "+" + clerk?.salesClerkPhoneNumber
      : null,
    email: clerk?.salesClerkEmail,
    product: chatBotProductEnum.M3,
  };

  if (is2StepFlowInFirstPart().value) {
    chatBotConfig.name = `${merchant?.merchantName}/${
      store.state.carts?.cartTag || ""
    }`;
    chatBotConfig.userType = UserTypes.CUSTOMER;
    chatBotConfig.product = isKiosk
      ? chatBotProductEnum.SELF_ONBOARDING
      : chatBotProductEnum.ECOMMERCE;
    chatBotConfig.clerkToken = null;
    chatBotConfig.salesClerkId = null;
  } else if (isDirectToCustomerFlow.value) {
    chatBotConfig.name = `${store.state.customer?.firstName || "Customer"}`;
    chatBotConfig.userType = UserTypes.CUSTOMER;
    chatBotConfig.product = chatBotProductEnum.D2C;
    chatBotConfig.email = store.state.customer?.email;
    chatBotConfig.phone = store.state.customer?.phone;

    delete chatBotConfig.clerkId;
    delete chatBotConfig.clerkName;
    delete chatBotConfig.clerkToken;
    delete chatBotConfig.salesClerkId;
  }

  return chatBotConfig;
});

watchEffect(() => {
  const merchant = store.state.merchant;
  isMerchantCountryLoaded.value = !!merchant?.merchant?.country;
  isSalesClerkLoaded.value = !!store.state.clerk?.clerk?.salesClerkId;
});
</script>
